import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppAbstractBackRouteHandler } from '../../AppRouter/app-router';

@Component({
  selector: 'search-bar-component',
  templateUrl: './search-bar-component.component.html',
  styleUrls: ['./search-bar-component.component.css']
})
export class SearchBarComponent implements OnInit {

  @Input() backRouteHandler!: AppAbstractBackRouteHandler;
  @Input() placeholder!: string;
  @Input() value!: string;

  clearOnceGuard: boolean = false;

  constructor(private router:Router) { }

  ngOnInit(): void {
  }

  onInputClick(){
    if(!this.clearOnceGuard){
      this.clearOnceGuard = true;
      this.onClearInput();
    }
  }

  backPress(){
    this.backRouteHandler.handleBackRoute();
  }

  onClearInput(){
    this.value = "";
  }

  onEnter(event: any){
    const keyword = event.target.value;
    this.router.navigate(['/search'], {
      queryParams: { keyword: keyword }
    });
  }

}